// Project the loaded building onto the CaptureLayout breadcrumb shape.
// Extracted from building-capture-screen.tsx so the screen file stays
// under the 500-line lint:max-lines cap.

interface BreadcrumbBuilding {
  name: string
  parent: {
    site: { id: string; name: string }
    base: { id: string; name: string }
  }
}

interface SegmentLink {
  label: string
  to: string
}

interface BuildingBreadcrumb {
  // Required by CaptureBreadcrumb — see PR #452 Codex review P2. The
  // parent of a building page is the site capture screen; if the site
  // hasn't loaded yet, fall back to the capture root so the Back
  // control still has a deterministic destination on direct/deep-link
  // loads.
  parentTo: string
  base?: SegmentLink
  site?: SegmentLink
  building: { label: string }
}

export function buildBuildingBreadcrumb(
  building: BreadcrumbBuilding | undefined,
): BuildingBreadcrumb {
  const base = building?.parent.base
  const site = building?.parent.site
  const parentTo =
    site && site.id !== ''
      ? `/capture/sites/${encodeURIComponent(site.id)}`
      : '/capture'
  return {
    parentTo,
    base:
      base && base.name !== ''
        ? {
            label: base.name,
            to: `/capture/bases/${encodeURIComponent(base.id)}`,
          }
        : undefined,
    site:
      site && site.name !== ''
        ? {
            label: site.name,
            to: `/capture/sites/${encodeURIComponent(site.id)}`,
          }
        : undefined,
    building: { label: building?.name ?? 'Building' },
  }
}
